import React from 'react';
import PropTypes from 'prop-types';

import DollarTextField from '../../core/text-fields/DollarTextField';

const StartingAtOverride = ({ values, defaults, onChange }) => (
  <DollarTextField
    label="Starting At Price"
    value={values.lowestPrice || defaults.lowestPrice || ''}
    onChange={onChange('lowestPrice')}
  />
);

const STARTING_AT_FEED = PropTypes.shape({ lowestPrice: PropTypes.string });

StartingAtOverride.propTypes = {
  values: STARTING_AT_FEED,
  defaults: STARTING_AT_FEED,
  onChange: PropTypes.func,
};

export default StartingAtOverride;



// WEBPACK FOOTER //
// ./src/feed-overrides/components/StartingAtOverride.jsx